import { DEMO_POSTS } from "data/posts";
import { PostDataType } from "data/types";
import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Avatar from "shared/Avatar/Avatar";
import Badge from "shared/Badge/Badge";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import NcImage from "shared/NcImage/NcImage";
import SocialsList from "shared/SocialsList/SocialsList";
import Textarea from "shared/Textarea/Textarea";
import { Helmet } from "react-helmet";
import { AppDispatch, RootState } from "redux/store";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import Label from "components/Label/Label";
import Input from "shared/Input/Input";
import { blog, getBlogdetails, getComments } from "redux/reducers/Properties/PropertiesSlice";
import successHandler from "utils/helpers/SuccessHandler";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import RecursiveComment from "shared/Comment/RecursiveComment";

const BlogSingle = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { slug } = useParams();
  const {
    blogsDetails,
    getComment
  } = useSelector((state: RootState) => state.property);
  const [blogs, setBlogs] = useState<any>(null);
  const [comments, setComments] = useState<any[]>([]);
  const [parentId, setParentId] = useState<number | null>(null);
  const contentInputRef = useRef<HTMLInputElement>(null);
  const title = blogs?.title
  const des = blogs?.description;
  const userImage = blogs?.user?.image;
  const userName = blogs?.user?.name || "Fones Mimi";
  const heroImage = blogs?.hero_image
  const href = blogs?.slug || "#";

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      content: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Full name is required"),
      email: Yup.string().email("Invalid email address").required("Email is required"),
      content: Yup.string().required("Message is required"),
    }),
    onSubmit: async (values, { resetForm, setSubmitting }) => {
      try {
        const payload = {
          comment: {
            name: values.name,
            email: values.email,
            content: values.content,
            parent_id: parentId || null,
          },
        };
        const response = await dispatch(blog({ slug, payload })).unwrap();
        if (response) {
          successHandler("Comment posted successfully");
          resetForm();
          setParentId(null);
          dispatch(getComments({ slug }))
          setComments((prev) => [...prev, response]);
        } else {
          alert("Failed to send message.");
        }
      } catch (error) {
        console.error("Error submitting contact form:", error);
      } finally {
        setSubmitting(false);
      }
    }

  });
  useEffect(() => {
    if (slug) {
      dispatch(getBlogdetails(slug));
      dispatch(getComments({ slug }))
        .unwrap()
        .then((data) => {
          setComments(data);
        });
    }
  }, [slug, dispatch]);

  useEffect(() => {
    if (blogsDetails) {
      setBlogs(blogsDetails);
    }
    if (getComment) {
      setComments(getComment);
    }
  }, [blogsDetails, getComment]);

  const handleReply = (id: number) => {
    setParentId(id);
    setTimeout(() => {
      if (contentInputRef.current) {
        contentInputRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
        contentInputRef.current.focus();
      }
    }, 100);
  };



  const renderHeader = () => {
    return (
      <header className="container rounded-xl">
        <div className="max-w-screen-md mx-auto space-y-5">
          <h1
            className=" text-neutral-900 font-semibold text-3xl md:text-4xl md:!leading-[120%] lg:text-4xl dark:text-neutral-100 max-w-4xl "
            title="Quiet ingenuity: 120,000 lunches and counting"
          >
            {title}
          </h1>
          <div className="w-full border-b border-neutral-100 dark:border-neutral-800"></div>
          <div className="flex flex-col items-baseline sm:flex-row sm:justify-between">
            <div className="nc-PostMeta2 flex items-center flex-wrap text-neutral-700 text-left dark:text-neutral-200 text-sm leading-none flex-shrink-0">
              <Avatar
                containerClassName="flex-shrink-0"
                sizeClass="w-8 h-8 sm:h-11 sm:w-11 "
                imgUrl={userImage}
              />
              <div className="ml-3">
                <div className="flex items-center">
                  {userName}
                </div>
              </div>
            </div>
            <div className="mt-3 sm:mt-0 sm:ml-3">
              <SocialsList />
            </div>
          </div>
          <NcImage
            className="w-full max-h-[400px] rounded-xl object-cover"
            containerClassName="container my-10 sm:my-12 "
            src={heroImage}
          />
          <div className="prose prose-neutral dark:prose-invert max-w-none trix-content">
            <div dangerouslySetInnerHTML={{ __html: des }} />
          </div>
        </div>
      </header>
    );
  };


  const renderAuthor = () => {
    return (
      <div className="max-w-screen-md mx-auto ">
        <div className="nc-SingleAuthor flex">
          <Avatar sizeClass="w-12 h-12 md:w-16 md:h-16"
            imgUrl={userImage} />
          <div className="flex flex-col ml-3 max-w-lg sm:ml-5 space-y-1">
            <span className="text-xs text-neutral-400 uppercase tracking-wider">
              WRITEN BY
            </span>
            <h2 className="text-lg font-semibold text-neutral-900 dark:text-neutral-200">
              {userName}
            </h2>
          </div>
        </div>
      </div>
    );
  };

  const renderCommentForm = () => {
    return (
      <div className="max-w-screen-md mx-auto pt-5">
        <h3 className="text-xl font-semibold text-neutral-800 dark:text-neutral-200">
          Responses ({comments?.length})
        </h3>
        <form
          className="nc-SingleCommentForm mt-5 grid grid-cols-1 gap-6"
          onSubmit={formik.handleSubmit}
          noValidate
        >
          <label className="block">
            <Label>Full name</Label>
            <Input
              id="name"
              name="name"
              type="text"
              placeholder="Example Doe"
              className="mt-1"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.name}
              ref={contentInputRef}
            />
            {formik.touched.name && formik.errors.name ? (
              <div className="warning">{formik.errors.name}</div>
            ) : null}
          </label>
          <label className="block">
            <Label>Email address</Label>
            <Input
              id="email"
              name="email"
              type="email"
              placeholder="example@example.com"
              className="mt-1"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
            />
            {formik.touched.email && formik.errors.email ? (
              <div className="warning">{formik.errors.email}</div>
            ) : null}
          </label>
          <label className="block">
            <Label>Message</Label>
            <Textarea
              id="content"
              name="content"
              rows={6}
              className="mt-1"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.content}
            />
            {formik.touched.content && formik.errors.content ? (
              <div className="warning mb-5">{formik.errors.content}</div>
            ) : null}
          </label>
          <div className="flex justify-end gap-5 mt-5">
            <ButtonPrimary type="submit" disabled={formik.isSubmitting}>
              Send Message
            </ButtonPrimary>
            {parentId !== null && (
              <ButtonSecondary
                onClick={() => {
                  setParentId(null);
                  formik.resetForm();
                  if (contentInputRef.current) {
                    contentInputRef.current.focus();
                  }
                }}
              >
                Cancel Reply
              </ButtonSecondary>
            )}

          </div>
        </form>
      </div>
    );
  };

  const renderCommentLists = () => {
    return (
      <div className="max-w-screen-md mx-auto">
        <ul className="nc-SingleCommentLists space-y-5">
          <li>
            {comments
              .filter((c: any) => c.parent_id === null)
              .map((comment: any) => (
                <RecursiveComment
                  key={comment.id}
                  comment={comment}
                  contentInputRef={contentInputRef}
                  handleReply={handleReply}
                />
              ))}
          </li>
        </ul>
      </div>
    );
  };

  return (
    <div className="nc-PageSingle pt-8 lg:pt-16 ">
      <Helmet>
        <title>Single Blog || Booking React Template</title>
      </Helmet>
      {renderHeader()}


      <div className="nc-SingleContent container space-y-10 mb-10">
        {/* {renderContent()} */}
        {/* {renderTags()} */}
        <div className="max-w-screen-md mx-auto border-b border-t border-neutral-100 dark:border-neutral-700"></div>
        {renderAuthor()}
        {renderCommentForm()}
        {renderCommentLists()}
      </div>

    </div>
  );
};

export default BlogSingle;
